import './sass/disability-calculator.scss';

import DisabilityRatingCalculator from './components/DisabilityRatingCalculator';

export default {
  DisabilityRatingCalculator,
};
